import { render } from "./PageFooter.vue?vue&type=template&id=f3d9b576&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"

import "./PageFooter.vue?vue&type=style&index=0&id=f3d9b576&scoped=true&lang=css"

import exportComponent from "C:\\Users\\admin\\Desktop\\Расчосков\\rascheskov_katarakta_lending\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d9b576"]])

export default __exports__